<template>
  <div style="margin-top: 10px;">
    <a-table :dataSource="dataSource" :columns="columns" :pagination="false">
      <template #bodyCell="{ column,record, index }">
        <template v-if="column.key === 'no'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'countryName'">
          <a type="link" @click="viewDrawerInfo(record.id)">{{
            record.countryCode
              ? `[${record.countryCode}]${record.countryName}`
              : record.countryName
          }}</a>
        </template>
        <template v-if="column.key === 'status'">
          {{ record.status === 0 ? '禁用' : '启用' }}
        </template>
        <template v-if="column.key === 'action'">
          <a-space>
            <a-button type="link" @click="editDrawerInfo(record.id)"
              >编辑</a-button
            >
            <a-popconfirm
              :title="
                record.status === 0
                  ? '你确定要启用该策略吗?'
                  : '你确定要禁用该策略吗?'
              "
              ok-text="确认"
              cancel-text="取消"
              @confirm="changeStatus(record.id, record.status)"
            >
              <a-button type="link">{{
                record.status === 0 ? '启用' : '禁用'
              }}</a-button>
            </a-popconfirm>

            <a-button type="link" @click="showLogModal(record.id)"
              >日志</a-button
            >
          </a-space>
        </template>
      </template>
    </a-table>
  </div>
  <div style="margin-top: 10px;display: flex; justify-content: space-between">
    <div>
      共 {{ searchForm.total }} 条记录 第 {{ searchForm.pageNum }} /
      {{ searchForm.pages }} 页
    </div>
    <a-pagination
      v-model:current="searchForm.pageNum"
      :pageSize="searchForm.pageSize"
      :page-size-options="pageSizeOptions"
      show-quick-jumper
      show-size-changer
      :total="searchForm.total"
      @change="onPageChange"
    >
      <template #buildOptionText="props">
        <span>{{ props.value }}条/页</span>
      </template>
    </a-pagination>
  </div>
</template>
<script>
import { defineComponent, inject, reactive, toRefs } from 'vue'
export default defineComponent({
  name: 'AddressRule',
  setup() {
    const state = reactive({
      pageSizeOptions: ['20', '50', '100']
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
})
</script>
